import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { useNavigate } from "react-router-dom"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"

import useAppPromotionTheme from "../hooks/useAppPromotionTheme"

export default function FastSpinTournament({ isLightMode }) {
  const isAppPromo = useAppPromotionTheme(isLightMode)
  const navigate = useNavigate()
  const [isMobile, setIsMobile] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  const data = promotionsData.find((promo) => promo.title === "Road to Glory")

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  // If the promo page is expired - throws error
  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Road to Glory Fastspin Tournament</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a
                href={
                  isAppPromo
                    ? "/promotion/".replace("/promotion", "/app-promotion")
                    : "/promotion/"
                }
              >
                Promotions
              </a>{" "}
              / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1>Road to Glory</h1>
                <h2>Fastspin Tournament Weekly Wins</h2>
                <h2>Wins ₱5,245,665 Total Prizes</h2>
                <div className="promotion-tnc-period">
                  <strong>Promo Period: </strong>
                  <span>May 04, 2026 - August 17, 2026</span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                <strong>Prize list</strong>
                <div className="table-wrapper">
                  <table
                    className="promotion-tnc-table"
                    style={{ minWidth: "0px" }}
                  >
                    <thead>
                      <tr>
                        <th>Rank</th>
                        <th>Prizes</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1st</td>
                        <td>₱115,606.94</td>
                      </tr>
                      <tr>
                        <td>2nd</td>
                        <td>₱57,803.47</td>
                      </tr>
                      <tr>
                        <td>3rd</td>
                        <td>₱23,121.39</td>
                      </tr>
                      <tr>
                        <td>4th - 10th</td>
                        <td>₱5,780.35</td>
                      </tr>
                      <tr>
                        <td>11th - 40th</td>
                        <td>₱2,890.17</td>
                      </tr>
                      <tr>
                        <td>41th - 70th</td>
                        <td>₱578.03</td>
                      </tr>
                      <tr>
                        <td>71th–100th</td>
                        <td>₱289.02</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <strong>Terms and Conditions:</strong>
                <ol>
                  <li>
                    Applicable Games All Fastspin slot games except Fishing
                    games.
                  </li>
                  <li>
                    If a player appears on more than one leaderboard, the player
                    will be able to win more than one prize. The prize will be
                    remitted in 72 hours after each tournament round ends,
                    please check changes in the player’s wallet balance.
                  </li>
                  <li>
                    If there are two or more players with identical win scores,
                    the player who scores it first will get a higher position on
                    the leaderboard.
                  </li>
                  <li>
                    Fastspin reserves the right to disqualify a player or group
                    of players if being found to use dishonest methods, cheat or
                    intimidate other players/operators, or found to be abusing
                    system loopholes to affect the result.
                  </li>
                  <li>
                    Fastspin reserves the right to modify the activity terms and
                    conditions without prior notice.
                  </li>
                </ol>
                {!isAppPromo && (
                  <div className="promotion-tnc-cta">
                    <a
                      className="promotion-cta-btn"
                      href="/slots/?provider=FASTSPIN"
                    >
                      PLAY NOW
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
